import { cn } from "@/lib/utils";
import { horizontalListSortingStrategy, SortableContext } from "@dnd-kit/sortable";
import { Table } from "@tanstack/react-table";
import { memo } from "react";
import { TanstackTableTh } from "./tanstack.table.th";

interface TanstackTableHeaderProps<T> {
  sticky?: "true" | "false";
  className?: string;
  table: Table<T>;
  columnOrder: string[];
}
export const TanstackTableHeader = <T extends object>({
  sticky = "false",
  className,
  table,
  columnOrder,
}: TanstackTableHeaderProps<T>) => {
  const stickyClass = {
    true: "sticky top-0 z-10",
    false: "",
  };
  return (
    <div className={cn("w-full border-b h-8 2xl:h-12", stickyClass[sticky], className)}>
      {table.getHeaderGroups().map((headerGroup) => (
        <div key={headerGroup.id} className="flex justify-center items-center h-full">
          <SortableContext items={columnOrder} strategy={horizontalListSortingStrategy}>
            {headerGroup.headers.map((header) => (
              <TanstackTableTh
                header={header}
                key={header.id}
                isPinable={true}
                isResizable={true}
              />
            ))}
          </SortableContext>
        </div>
      ))}
    </div>
  );
};

export const MemoizedTanstackTableHeader = memo(
  TanstackTableHeader,
  (prev, next) => prev.table.options.data === next.table.options.data
) as typeof TanstackTableHeader;
